const toSegments = (path: string) => path.split('/').filter(Boolean)

/**
 * The value of the `table` entry whose pattern best matches `path`, or
 * `undefined` when no pattern matches.
 *
 * Patterns are absolute paths; a `:segment` matches any single segment, and a
 * pattern also matches every path beneath it. The best match wins — most
 * literal segments first, then longest — so `/venues/list` beats
 * `/venues/:venueSlug`, and a subtree entry covers every tab beneath it.
 */
export const bestRouteMatch = <T>(
  table: Record<string, T>,
  path: string
): T | undefined => {
  const segments = toSegments(path)

  let best: T | undefined
  let bestScore = -1

  for (const [pattern, value] of Object.entries(table)) {
    const patternSegments = toSegments(pattern)
    if (patternSegments.length > segments.length) continue

    let literals = 0
    const matches = patternSegments.every((segment, index) => {
      if (segment.startsWith(':')) return true
      literals += 1
      return segment === segments[index]
    })
    if (!matches) continue

    // Prefer the pattern with the most literal segments, then the longest, so
    // a static sibling always beats a `:param` and a nested entry beats its
    // parent subtree.
    const score = literals * 100 + patternSegments.length
    if (score > bestScore) {
      bestScore = score
      best = value
    }
  }

  return best
}
